import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlSegment } from '@angular/router';
import { AppInitService } from '@app/services';

export const appInitializedGuard: CanMatchFn = (_route, segments: UrlSegment[]) => {
  const appInitService = inject(AppInitService);
  const router = inject(Router);

  if (appInitService.firstInitDone) {
    return true;
  }

  const fullUrl =
    router.currentNavigation()?.extractedUrl.toString().replace(/^\//, '') ?? segments.map((s) => s.path).join('/');
  if (fullUrl) {
    appInitService.pendingUrl = fullUrl;
  }

  return router.createUrlTree(['/splash']);
};
